import React, { useState, useEffect } from "react";
import { Tabs, Tab, Image, Row } from "react-bootstrap";

const FoodCategoryTabs = () => {
  const [activeKey, setActiveKey] = useState("village");
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 992); // Mobile breakpoint
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tabs = [
    {
      key: "village",
      label: "Village + Limited Food (package)",
      disabled: false,
      content: (

            <div className="sp-cnt-in cul-pk text-center">
    <div className="star">*Conditions apply
        <br />*5% Extra charges during Weekend &amp; Hoiliday
        <br />*10% Extra charges during 31st Dec, 1st Jan</div>
    <div className="sp-cnt-in2">        
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>       
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
        <div className="package-hdg3">Village + Limited Food</div>
        <ul className="fee">
            <li>₹700*<span>Per Head Adult</span></li>
            <li>₹525*<span>Per Head Child</span><small>(2.5 FT to 3.5 FT)</small></li>
        </ul>
        <div className="ltd-fd-bx">
            <h3><span className="text-left">Includes</span>Limited Food <span className="text-right">Package Menu</span></h3></div>
        <div className="menu-blk">
            <div className="wrap first">
                <div className="c1">Garlic Chutney Bajra Roti</div>
                <div className="c2"></div>
            </div>
            <div className="wrap">
                <div className="c1">Jaggery Butter Makka Roti</div>
                <div className="c2"></div>
            </div>
            <div className="wrap">
                <div className="c1">Kadi Kachori / Potato Bonda / Chilli Bada</div>
                <div className="c2">Any One</div>
            </div>
            <div className="wrap">
                <div className="c1">Onion Pakodi / Potato Pakodi / Dal Mug Pakodi</div>
                <div className="c2">Any One</div>
            </div>
            <div className="wrap">
                <div className="c1">Chana Chat</div>
                <div className="c2"></div>
            </div>
            <div className="wrap">
                <div className="c1">Spl. Banarasi Masala Tea</div>
                <div className="c2"></div>
            </div>
            <div className="wrap">
                <div className="c1">Tomato Soup</div>
                <div className="c2"></div>
            </div>
            <div className="wrap">
                <div className="c1">Spl. Jodhpuri Masala Tea</div>
                <div className="c2"></div>
            </div>
            <div className="wrap">
                <div className="c1">Jaljeera Water (or) Sharbat</div>
                <div className="c2"></div>
            </div>
        </div>
        <div className="package-hdg3">Complementary Cultural Limited Food</div>
        <div className="mb20 row">
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/puppet-show.png`} fluid /></figure>
                    <div className="tl">Puppet Show</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/rope-balancing.png`} fluid /></figure>
                    <div className="tl">Rope Balancing</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/bioscope.png`} fluid /></figure>
                    <div className="tl">Bioscope</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/magician.png`} fluid /></figure>
                    <div className="tl">Magician</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/snakes-and-ladders.png`} fluid /></figure>
                    <div className="tl">Snake And Ladder</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/head-oil-massage.png`} fluid /></figure>
                    <div className="tl">Head Oil Massage</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/palm-reader.png`} fluid /></figure>
                    <div className="tl">Hindi Palm Reader</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/parrot-astrology.png`} fluid /></figure>
                    <div className="tl">Parrot Hindi Astrology</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/mehendi.png`} fluid /></figure>
                    <div className="tl">Mehendi</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/potter.png`} fluid /></figure>
                    <div className="tl">Potter</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/cultural-body-therapy.png`} fluid /></figure>
                    <div className="tl">Cultural Body Therapy</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/haryanvi-dance.png`} fluid /></figure>
                    <div className="tl">Cultural Dance</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/boating.png`} fluid /></figure>
                    <div className="tl">Boating</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/maze.png`} fluid /></figure>
                    <div className="tl">Maze</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/tool-maker.png`} fluid /></figure>
                    <div className="tl">Tool maker</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/shenai.png`} fluid /></figure>
                    <div className="tl">Shehnai</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/dummy-horse-dance.png`} fluid /></figure>
                    <div className="tl">Dummy Horse Dance</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/live-cooking.png`} fluid /></figure>
                    <div className="tl">Live Cooking</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/joker.png`} fluid /></figure>
                    <div className="tl">Joker</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/traditional-singer.png`} fluid /></figure>
                    <div className="tl">Traditional Folk Live Singer</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/temples.png`} fluid /></figure>
                    <div className="tl">Temples</div>
                </div>
            </div>
        </div>
          <Row>
            <div className="contact-wrap">
              <div className='whatsapp-blk'>
                <p>For more updates please</p>             
                  <div className='btn-whatsapp'><a href='https://wa.me/9884334346' target='_blank'><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid /> 9884334346</a></div>
              </div>
            </div>
          </Row>
    </div>
</div>
      ),
    },
    {
      key: "special",
      label: "Category - I  Special Thali + Unlimited Food (additional)",
      disabled: false,
      content: (
           <div className="sp-cnt-in cul-pk text-center">
    <div className="star sec">*Conditions apply
        <br />*open sky buffet</div>
    <div className="sp-cnt-in2">        
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>       
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
        <div className="package-hdg3">Special Thali + Unlimited Food (additional)</div>
        <ul className="fee">
            <li>₹275<span>Per Head Adult</span></li>
            <li>₹175<span>Per Head Child</span><small>(2.5 FT to 3.5 FT)</small></li>
        </ul>
        <div className="ltd-fd-bx">
            <h3><span className="text-left">Includes</span>Limited Food</h3>
            <h4>+</h4>
            <h3>Unlimited Thali <span>Non AC* Dining Menu</span></h3></div>
        <div className="menu-blk">
            <h4>Roti</h4>
            <div className="wrap first">
                <div className="c1">Ghee Roti / Plain Roti</div>
                <div className="c2"></div>
            </div>
            <h4>Puri</h4>
            <div className="wrap first">
                <div className="c1">Plain Puri / Palak Puri / Methi Puri</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Sabzi</h4>
            <div className="wrap first">
                <div className="c1">Matar Paneer / Kadai Paneer / Shahi Paneer / Paneer Masala</div>
                <div className="c2">Any One Weekend</div>
            </div>
            <div className="wrap">
                <div className="c1">Aloo Piyaz / Dum Aloo / Aloo Banarasi / Mix Veg</div>
                <div className="c2">Any One</div>
            </div>
            <div className="wrap">
                <div className="c1">Palak Mogar / Bhindi Piyaz / Bhindi Masala Mix Kofta / MIx Veg</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Gatta Sabzi</h4>
            <div className="wrap first">
                <div className="c1">Dal Plain / Panchwela Dal</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Batti</h4>
            <div className="wrap first">
                <div className="c1">Masala Batti / Plain Batti</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Rice</h4>
            <div className="wrap first">
                <div className="c1">Plain Rice / Veg Rice / Jera Rice / Pudina Rice / Lemon Rice / Curd Rice / Sambar Rice</div>
                <div className="c2">Any Three</div>
            </div>
            <h4>Sweet</h4>
            <div className="wrap first">
                <div className="c1">Churma / Gulab Churma</div>
                <div className="c2">Any One</div>
            </div>
            <div className="wrap">
                <div className="c1">Jalebi / Malupua</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Chutney</h4>
            <div className="wrap first">
                <div className="c1">Pudina / Garlic</div>
                <div className="c2"></div>
            </div>
            <h4>In Addition</h4>
            <div className="wrap first">
                <div className="c1">Pappad Fry / Papad Sada / Lemon Piece / Onion / Pickle</div>
                <div className="c2"></div>
            </div>
        </div>
        <div className="compt-bx">
            <div className="plus">+</div>
            <div className="compt-bx-in">
                <h3>Complimentary <span>Welcoming Travel By</span></h3></div>
        </div>
        <div className="mb20 d-flex justify-content-center align-self-center row">
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/camel-ride.png`} fluid /></figure>
                    <div className="tl">Camel Ride</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/horse-cart-ride.png`} fluid /></figure>
                    <div className="tl">Horse Cart</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/camel-cart-ride.png`} fluid /></figure>
                    <div className="tl">Camel Cart</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx single">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/bullock-cart-ride.png`} fluid /></figure>
                    <div className="tl">Bullock Cart</div>
                </div>
            </div>
        </div>
          <Row>
            <div className="contact-wrap">
              <div className='whatsapp-blk'>
                <p>For more updates please</p>             
                  <div className='btn-whatsapp'><a href='https://wa.me/9884334346' target='_blank'><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid /> 9884334346</a></div>
              </div>
            </div>
          </Row>
    </div>
</div>
      ),
    },
    {
      key: "emperor",
      label: "Category - II Emperor Thali (Coming Soon)",
      disabled: true,
      content: (
        <div className="sp-cnt-in cul-pk text-center">
    <div className="sp-cnt-in2">        
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>       
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
        <div className="package-hdg3">Emperor Thali + Unlimited Food (additional)</div>
        <ul className="fee">
            <li>₹450<span>Per Head Adult</span></li>
            <li>₹300<span>Per Head Child</span><small>(2.5 FT to 3.5 FT)</small></li>
        </ul>
        <div className="ltd-fd-bx">
            <h3><span className="text-left">Includes</span>Limited Food</h3>
            <h4>+</h4>
            <h3>Unlimited Food <span className="text-left">+ AC Dining <br /> + Bharaf (ICE) Gola<br /> + Welcoming Camel Safari<br /> + Rajasthani Pagri @ dining</span></h3></div>
        <div className="menu-blk">
            <h4>Roti</h4>
            <div className="wrap first">
                <div className="c1">Ghee Roti / Plain Roti</div>
                <div className="c2"></div>
            </div>
            <h4>Puri</h4>
            <div className="wrap first">
                <div className="c1">Plain Puri / Palak Puri / Methi Puri</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Sabzi</h4>
            <div className="wrap first">
                <div className="c1">Matar Paneer / Kadai Paneer / Shahi Paneer / Paneer Masala</div>
                <div className="c2">Any One Weekend</div>
            </div>
            <div className="wrap">
                <div className="c1">Aloo Piyaz / Dum Aloo / Aloo Banarasi / Mix Veg</div>
                <div className="c2">Any One</div>
            </div>
            <div className="wrap">
                <div className="c1">Palak Mogar / Bhindi Piyaz / Bhindi Masala Mix Kofta / MIx Veg</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Gatta Sabzi</h4>
            <div className="wrap first">
                <div className="c1">Dal Plain / Panchwela Dal</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Batti</h4>
            <div className="wrap first">
                <div className="c1">Masala Batti / Plain Batti</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Rice</h4>
            <div className="wrap first">
                <div className="c1">Plain Rice / Veg Rice / Jera Rice / Pudina Rice / Lemon Rice / Curd Rice / Sambar Rice</div>
                <div className="c2">Any Three</div>
            </div>
            <h4>Sweet</h4>
            <div className="wrap first">
                <div className="c1">Churma / Gulab Churma</div>
                <div className="c2">Any One</div>
            </div>
            <div className="wrap">
                <div className="c1">Jalebi / Malupua</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Chutney</h4>
            <div className="wrap first">
                <div className="c1">Pudina / Garlic</div>
                <div className="c2"></div>
            </div>
            <h4>In Addition</h4>
            <div className="wrap first">
                <div className="c1">Pappad Fry / Papad Sada / Lemon Piece / Onion / Pickle</div>
                <div className="c2"></div>
            </div>
        </div>
        <div className="compt-bx">
            <div className="plus">+</div>
            <div className="compt-bx-in">
                <h3>Complimentary <span>Welcoming Travel By</span></h3></div>
        </div>
        <div className="mb20 d-flex justify-content-center align-self-center row">
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/camel-ride.png`} fluid /></figure>
                    <div className="tl">Decorative Camel Safari</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/horse-cart-ride.png`} fluid /></figure>
                    <div className="tl">Horse Cart</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/camel-cart-ride.png`} fluid /></figure>
                    <div className="tl">Camel Cart</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx single">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/bullock-cart-ride.png`} fluid /></figure>
                    <div className="tl">Bullock Cart</div>
                </div>
            </div>
        </div>
          <Row>
            <div className="contact-wrap">
              <div className='whatsapp-blk'>
                <p>For more updates please</p>             
                  <div className='btn-whatsapp'><a href='https://wa.me/9884334346' target='_blank'><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid /> 9884334346</a></div>
              </div>
            </div>
          </Row>
    </div>
</div>
      ),
    },
    {
      key: "royal",
      label: "Category - III Royal Thali (Coming Soon)",
      disabled: true,
      content: (
         <div className="sp-cnt-in cul-pk text-center">
    <div className="star sin">*Conditions apply</div>
    <div className="sp-cnt-in2">
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>       
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
        <div className="package-hdg3">Royal Thali + Unlimited Food (additional)</div>
        <ul className="fee">
            <li>₹650<span>Per Head Adult</span></li>
            <li>₹500<span>Per Head Child</span><small>(2.5 FT to 3.5 FT)</small></li>
        </ul>
        <div className="ltd-fd-bx">
            <h3><span className="text-left">Includes</span>Limited Food</h3>
            <h4>+</h4>
            <h3>Unlimited Food <span className="text-left">+ AC Dining <br /> + Bharaf (ICE) Gola<br /> + Welcoming Safari Camel<br /> + Traditional Rajasthani dress* <br /> + Rajasthani Pagri @ dining</span></h3></div>
        <div className="menu-blk">
            <h4>Roti</h4>
            <div className="wrap first">
                <div className="c1">Ghee Roti / Plain Roti</div>
                <div className="c2"></div>
            </div>
            <h4>Puri</h4>
            <div className="wrap first">
                <div className="c1">Plain Puri / Palak Puri / Methi Puri</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Sabzi</h4>
            <div className="wrap first">
                <div className="c1">Matar Paneer / Kadai Paneer / Shahi Paneer / Paneer Masala</div>
                <div className="c2">Any One Weekend</div>
            </div>
            <div className="wrap">
                <div className="c1">Aloo Piyaz / Dum Aloo / Aloo Banarasi / Mix Veg</div>
                <div className="c2">Any One</div>
            </div>
            <div className="wrap">
                <div className="c1">Palak Mogar / Bhindi Piyaz / Bhindi Masala Mix Kofta / MIx Veg</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Gatta Sabzi</h4>
            <div className="wrap first">
                <div className="c1">Dal Plain / Panchwela Dal</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Batti</h4>
            <div className="wrap first">
                <div className="c1">Masala Batti / Plain Batti</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Rice</h4>
            <div className="wrap first">
                <div className="c1">Plain Rice / Veg Rice / Jera Rice / Pudina Rice / Lemon Rice / Curd Rice / Sambar Rice</div>
                <div className="c2">Any Three</div>
            </div>
            <h4>Sweet</h4>
            <div className="wrap first">
                <div className="c1">Churma / Gulab Churma</div>
                <div className="c2">Any One</div>
            </div>
            <div className="wrap">
                <div className="c1">Jalebi / Malupua</div>
                <div className="c2">Any One</div>
            </div>
            <h4>Chutney</h4>
            <div className="wrap first">
                <div className="c1">Pudina / Garlic</div>
                <div className="c2"></div>
            </div>
            <h4>In Addition</h4>
            <div className="wrap first">
                <div className="c1">Pappad Fry / Papad Sada / Lemon Piece / Onion / Pickle</div>
                <div className="c2"></div>
            </div>
        </div>
        <div className="compt-bx">
            <div className="plus">+</div>
            <div className="compt-bx-in">
                <h3>Complimentary <span>Welcoming Travel By</span></h3></div>
        </div>
        <div className="mb20 d-flex justify-content-center align-self-center row">
            <div className="cul-bx mb0 col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/camel-ride.png`} fluid /></figure>
                    <div className="tl">Decorative Camel Safari</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/horse-cart-ride.png`} fluid /></figure>
                    <div className="tl">Horse Cart</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/camel-cart-ride.png`} fluid /></figure>
                    <div className="tl">Camel Cart</div>
                </div>
            </div>
            <div className="cul-bx col-lg-4 col-sm-6">
                <div className="item-bx single">
                    <figure><Image src={`${process.env.PUBLIC_URL}/images/bullock-cart-ride.png`} fluid /></figure>
                    <div className="tl">Bullock Cart</div>
                </div>
            </div>
        </div>
          <Row>
            <div className="contact-wrap">
              <div className='whatsapp-blk'>
                <p>For more updates please</p>             
                  <div className='btn-whatsapp'><a href='https://wa.me/9884334346' target='_blank'><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid /> 9884334346</a></div>
              </div>
            </div>
          </Row>
    </div>
</div>
      ),
    },
  ];

  return (
    <div>
      {/* Mobile Select Dropdown */}
      {isMobile && (
        <select
          className="form-select mb-3"
          value={activeKey}
          onChange={(e) => {
            const tab = tabs.find((t) => t.key === e.target.value);
            if (tab && !tab.disabled) {
              setActiveKey(e.target.value);
            }
          }}
        >
          {tabs.map((tab) => (
            <option key={tab.key} value={tab.key} disabled={tab.disabled}>
              {tab.label}
            </option>
          ))}
        </select>
      )}

      {/* Desktop Tabs */}
      <Tabs
        activeKey={activeKey}
        onSelect={(k) => {
          const tab = tabs.find((t) => t.key === k);
          if (tab && !tab.disabled) {
            setActiveKey(k);
          }
        }}
        id="food-category-tabs"
        className={`food-category mb-3 ${!isMobile ? "nav-justified" : ""}`}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.key}
            eventKey={tab.key}
            title={tab.label}
            disabled={tab.disabled}
          >
            {tab.content}
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default FoodCategoryTabs;
